import lodash from 'lodash';
import { composeReducers } from 'common/util/composeReducers';
import {
    LOAD_DATA_SOURCE_LIST,
    LOAD_DATA_SOURCE,
    UNLOAD_DATA_SOURCE,
    WRITE_DATA_SOURCE_VALUES,
    WRITE_DATA_SOURCE_SAVE_SUCCESS,
    LOAD_DATA_SOURCE_LOG,
    DATA_SOURCE_SUBMITTING
} from 'pages/dataSource/actions/dataSource';

export function loadDataSourceList(state, action) {
    if (!action || action.type !== LOAD_DATA_SOURCE_LIST) {
        return state;
    }
    
    const dataSources = lodash.chain(action.payload.dataSources)
        .sortBy([ds => ds.name.toLowerCase()])
        .map(dataSource => {
            dataSource.parameters = JSON.parse(dataSource.parameters);
            return dataSource;
        })
        .keyBy('id')
        .value();
    const dataSourcesTotalCount = action.payload.dataSourcesTotalCount;

    return {
        ...state,
        dataSources,
        dataSourcesTotalCount,
        dataSourceEditor: {
            ...state.dataSourceEditor
        }
    };
}

export function loadDataSource(state, action) {
    if (!action || action.type !== LOAD_DATA_SOURCE) {
        return state;
    }

    const dataSource = action.payload.dataSource;
    const dataTypes = action.payload.descriptorDataTypes || state.dataSourceEditor.dataTypes;
    const isSaveSuccessful = action.payload.isSaveSuccessful;
    const parameters = JSON.parse(dataSource.parameters);
    const selectedDataSource = {...dataSource, parameters};
    const sortOrder = ascertainSortOrder(parameters.values);

    return {
        ...state,
        dataSourceEditor: {
            ...state.dataSourceEditor,
            dataSource: selectedDataSource,
            dataSourceDataType: parameters.dataType,
            values: parameters.values,
            isSaveSuccessful,
            dataTypes,
            sortOrder,
            isSubmitting: false
        }
    };
}

function ascertainSortOrder(dataSourceValues) {
    const sortedDataSourceValues = lodash.sortBy(dataSourceValues, 
        [dsv => !lodash.isNaN(parseInt(dsv.value)) ? parseInt(dsv.value) : dsv.value.toLowerCase()]);
    return lodash.isEqual(dataSourceValues, sortedDataSourceValues) ? 'asc' : 'desc';
}

export function writeDataSourceSaveSuccess(state, action) {
    if (!action || action.type !== WRITE_DATA_SOURCE_SAVE_SUCCESS) {
        return state;
    }

    return {
        ...state,
        dataSourceEditor: {
            ...state.dataSourceEditor,
            isSaveSuccessful: true
        }
    };
}

export function unloadDataSource(state, action) {
    if (!action || action.type !== UNLOAD_DATA_SOURCE) {
        return state;
    }

    return {
        ...state,
        dataSourceEditor: {}
    };
}

export function writeDataSourceValues(state, action) {
    if (!action || action.type !== WRITE_DATA_SOURCE_VALUES) {
        return state;
    }
    
    return {
        ...state,
        dataSourceEditor: {
            ...state.dataSourceEditor,
            values: action.payload.values
        }
    };
}

export const loadDataSourceLog = (state, action) => {
    if (!action || action.type !== LOAD_DATA_SOURCE_LOG) {
        return state;
    }

    return {
        ...state,
        dataSourceLogs: action.payload
    };
};

export const dataSourceSubmitting = (state, action) => {
    if (!action || action.type !== DATA_SOURCE_SUBMITTING) {
        return state;
    }

    return {
        ...state,
        dataSourceEditor: {
            ...state.dataSourceEditor,
            isSubmitting: action.payload,
        }
    };
};

export default composeReducers(
    loadDataSourceList,
    loadDataSource,
    unloadDataSource,
    writeDataSourceValues,
    writeDataSourceSaveSuccess,
    loadDataSourceLog,
    dataSourceSubmitting
);
